import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

export function AppLayout() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const location = useLocation();

  // El drawer (tablet/mobile) se cierra solo al navegar a otra ruta.
  useEffect(() => {
    setMenuAbierto(false);
  }, [location.pathname]);

  // Tecla Escape cierra el drawer, sin necesidad de un focus-trap completo.
  useEffect(() => {
    if (!menuAbierto) return;
    function alPresionarTecla(evento: KeyboardEvent) {
      if (evento.key === "Escape") setMenuAbierto(false);
    }
    window.addEventListener("keydown", alPresionarTecla);
    return () => window.removeEventListener("keydown", alPresionarTecla);
  }, [menuAbierto]);

  return (
    <div className="min-h-screen bg-fondo">
      <Sidebar abierto={menuAbierto} onCerrar={() => setMenuAbierto(false)} />
      <Header onAbrirMenu={() => setMenuAbierto(true)} />
      <main className="pt-14 lg:pl-60">
        <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
